import ProductDraftStore from './ProductDraftStore'

export default ProductDraftStore
